import type {BigCalendarEvent} from 'platform/big-calendar';

import {isNilOrEmpty} from 'ramda-adjunct';

import type {TestDriveResponseBody} from '@dms/api/sales';

import {EMPTY_PLACEHOLDER, parseDate} from 'shared/web';

export interface TestDriveEventData {
  userId: string;
  state: 'planned' | 'completed' | 'cancelled';
  note: string | null;
  internalNote: string | null;
  hasReturnedAt: boolean;
  scheduledAt: string;
  returnedAt: string;
}

export interface TestDriveCalendarEvent extends BigCalendarEvent {
  testDriveData: TestDriveEventData;
  businessCaseId: string | null;
  customerId: string;
  vehicleId: string;
}

export function transformTestDriveToCalendarEvent(
  testDrive: TestDriveResponseBody
): TestDriveCalendarEvent {
  const scheduledDate = parseDate(testDrive.scheduledAt);
  const endDate = testDrive.returnedAt ? parseDate(testDrive.returnedAt) : scheduledDate;

  const eventEndDate = testDrive.returnedAt
    ? endDate
    : parseDate(scheduledDate.getTime() + 60 * 60 * 1000);

  const customerName =
    testDrive.customerTradeName ||
    `${testDrive.customerFoundingPersonFirstName || ''} ${testDrive.customerFoundingPersonLastName || ''}`.trim() ||
    EMPTY_PLACEHOLDER;

  return {
    id: testDrive.id,
    title: customerName,
    start: scheduledDate,
    end: eventEndDate,
    icon: isNilOrEmpty(testDrive.customerTradeName)
      ? 'sidebar/customers'
      : 'communication/business',
    color: 'palettes.blue.50.100',
    isReadOnly: false,
    businessCaseId: testDrive.businessCaseId,
    customerId: testDrive.customerId,
    vehicleId: testDrive.vehicleId,
    alternative: testDrive.state === 'completed',

    testDriveData: {
      userId: testDrive.userId,
      state: testDrive.state,
      note: testDrive.note,
      scheduledAt: testDrive.scheduledAt,
      returnedAt: testDrive.returnedAt ?? eventEndDate.toISOString(),
      internalNote: testDrive.internalNote,
      hasReturnedAt: testDrive.returnedAt !== null,
    },
  };
}
